import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";

import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { BoletaDeIntermediacaoPermissao } from "app/shared/permissoes-enum";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class HomeComponent extends BaseComponent implements OnInit {
    user: any;
    dateNow = Date.now();
    hasPermissionBoletas = false;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public _router: Router,
        private _authService: AuthService
    ) {
        super(dialog, snackBar);
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);
    }

    ngOnInit() {
        this.checkPermissions();
    }

    checkPermissions() {
        this.hasPermissionBoletas = this._authService.isPermissao([
            BoletaDeIntermediacaoPermissao.LISTAR,
        ]);
    }
}
